var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('Header'),_c('div',{class:_vm.isShowFoot==false?'conter conter2':'conter',attrs:{"id":"content"}},[_c('router-view')],1),(_vm.isShowFoot)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }